export default {
  data() {
    return {
      hour: null,
      minute: null,
    };
  },

  computed: {
    hours() {
      const start = 0;
      const end = 24;

      const hours = [];

      for (let i = start; i < end; i += 1) {
        hours.push({
          id: `${i}`.padStart(2, '0'),
          label: `${i}`.padStart(2, '0'),
        });
      }
      return hours;
    },
    minutes() {
      const end = 59;

      const days = [];

      for (let i = 0; i < end; i += 5) {
        days.push({
          id: `${i}`.padStart(2, '0'),
          label: `${i}`.padStart(2, '0'),
        });
      }

      return days;
    },

    months() {
      return [
        { id: 1, label: 'January' },
        { id: 2, label: 'February' },
        { id: 3, label: 'March' },
        { id: 4, label: 'April' },
        { id: 5, label: 'May' },
        { id: 6, label: 'June' },
        { id: 7, label: 'July' },
        { id: 8, label: 'August' },
        { id: 9, label: 'September' },
        { id: 10, label: 'October' },
        { id: 11, label: 'November' },
        { id: 12, label: 'December' },
      ];
    },
  },

  methods: {
    setSelected() {
      if (this.minute === null || this.hour === null) {
        this.$emit('change', null);
        return;
      }

      this.$emit('change', `${this.hour}:${this.minute}`);
    },
    setInitialValue() {
      if (!this.question.initialVal || !this.question.initialVal.length) return;

      const date = new Date(this.question.initialVal);

      this.hour = `${date.getUTCHours()}`.padStart(2, '0');
      this.minute = `${date.getUTCMinutes()}`.padStart(2, '0');

      this.$emit('change', `${this.hour}:${this.minute}`);
    },
  },
};
